import { ROLES_INFO } from "@/utils/userRoles";
import { isExportCustomer } from '@/utils/userFolder'

export default {
    computed: {
        getUsernameFirstLetters() {
            const name = this.$auth.user.name || this.$auth.user.email;

            if (name) {
                return name
                    .split(" ")
                    .slice(0, 2)
                    .map((str) => str.charAt(0).toUpperCase())
                    .join("");
            }

            return "";
        },

        getUsername() {
            return this.$auth.user.name || this.$auth.user.email
        },

        getUserRoles() {
            return Object
                .keys(ROLES_INFO)
                .filter(r => this.$auth.user.scope.includes(r))
                .map(r => ROLES_INFO[r].title)
                .join(', ') || 'User'
        },

        getIsExportCustomer() {
            return isExportCustomer(this.$auth.user?.userFolder)
        }
    }
}